module.exports = __webpack_public_path__ + "static/media/fffd804a-b8ed-4cf1-a1ed-7853d37064ea_1.b85b149912bbd71d0c05a591fc69153f.634e25c9.jpeg";